import React from 'react';
import { FormFile } from 'react-bootstrap';

export default props => {
    return <FormFile {...props} ></FormFile>;
};
